<template>
  <div class="dashboardCashflowSummary">
    <div class="d-flex justify-content-center">
      <ReportsDashboardMetric
        class="month"
        :value="getDashboardCashflowTotals.month"
        legend="denne måneden"
        color="secondary"
        format="currency"
      />
    </div>
    <div class="dashboardCashflowSummary__grid mt-4">
      <ReportsDashboardMetric
        class="today"
        :value="getDashboardCashflowTotals.day"
        legend="i dag"
        format="currency"
        color="secondary"
        small
      />
      <ReportsDashboardMetric
        class="week"
        :value="getDashboardCashflowTotals.week"
        legend="denne uken"
        format="currency"
        color="secondary"
        small
      />
      <ReportsDashboardMetric
        class="year"
        :value="getDashboardCashflowTotals.year"
        legend="i år"
        format="currency"
        color="secondary"
        small
      />
    </div>
    <div class="d-flex justify-content-center mt-2">
      <button class="btn btn-sm btn-outline-secondary" @click="goToPaymentList">Til rapport</button>
    </div>
  </div>
</template>

<script>
import ReportsDashboardMetric from '@/components/reports/dashboard/ReportsDashboardMetric';
import { mapGetters } from 'vuex';

export default {
  name: 'DashboardCashflowSummary',
  computed: {
    ...mapGetters('reports', ['getDashboardCashflowTotals']),
  },
  components: {
    ReportsDashboardMetric,
  },
  methods: {
    goToPaymentList() {
      this.$router.push({
        name: 'reports_payments',
      });
    },
  },
};
</script>

<style scoped lang="scss">
.dashboardCashflowSummary__grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
  gap: 0rem 1rem;
}
</style>
